import { Functionality } from '@frontend/functionality/types';
import { DefaultModalProps, ModalType, useModals } from '@frontend/modal';
import { ReactNode } from 'react';

import { WizardModal, wizardModalPaneClassName } from '../../../wizard-rendering/wizard-modal/wizard-modal.component';

export interface OpenApplicationCreateParams {
    openModal: ReturnType<typeof useModals>['openModal'];
    modalId: string;
    renderDefaultModal: () => ReactNode;
    modalProps?: Record<string, unknown>;
    modalOptions?: Omit<DefaultModalProps, 'show' | 'handleClose'>;
    wizardContext?: {
        functionality: Functionality;
        wizardId: string;
    } | null;
}

export function openApplicationCreate({
    openModal,
    modalId,
    renderDefaultModal,
    modalProps = {},
    modalOptions = { type: ModalType.PANE, className: 'max-w-[600px]' },
    wizardContext
}: OpenApplicationCreateParams) {
    if (wizardContext) {
        openModal(
            `${modalId}-wizard-${wizardContext.functionality.id}`,
            () => (
                <WizardModal
                    functionality={wizardContext.functionality}
                    wizardId={wizardContext.wizardId}
                />
            ),
            modalProps,
            {
                type: ModalType.PANE,
                ...modalOptions,
                className: wizardModalPaneClassName
            }
        );
        return;
    }

    openModal(modalId, renderDefaultModal, modalProps, modalOptions);
}
